/* eslint-disable react/prop-types */
import React from 'react';

const MegaMenuLink = ({ title, description, iconSrc, href, target, key }) => (
  <div className="mega-menu__content-link" key={key}>
    {description ? (
      <div className="mega-menu__content-link-description">
        <a
          href={href}
          target={target}
          className="mega-menu__content-link-title"
        >
          {title}
        </a>
        <span className="mega-menu__content-link-text">{description}</span>
      </div>
    ) : (
      <a href={href} target={target}>
        {title}
      </a>
    )}
    {iconSrc && <img src={iconSrc} width={20} height={20} />}
  </div>
);

export default MegaMenuLink;
